<template>
  <base-card class="mb-2">
    <p class="border-b mb-2 pb-1 text-sm font-semibold">
      {{ $t(`mygwf.components.Card.filters`) }}
    </p>
    <div class="device-group-filters flex justify-between space-x-5 mt-2 items-center">
      <base-input class="flex-1" v-model.trim="name" size="sm" label="group_name" clearable />

      <div class="flex-1">
        <CompanySelect :filterArray="companies" />
      </div>
    </div>
  </base-card>
</template>

<script>
import {BaseInput, BaseSelect, BaseIcon, BaseButtonIcon, BaseCard} from '@/components/base'
import CompanySelect from '@/components/shared/CompanySelect.vue'
import _isEmpty from 'lodash-es/isEmpty'

export default {
  components: {
    BaseInput,
    BaseSelect,
    BaseIcon,
    CompanySelect,
    BaseButtonIcon,
    BaseCard,
  },

  data() {
    return {
      visible: false,
      name: this.$route.query.name || '',
      companies: this.$route.query.company ? [...this.$route.query.company] : [],
    }
  },

  watch: {
    $route(n, o) {
      if (_isEmpty(n.query)) {
        this.reset()
      }
    },

    name(n, o) {
      this.$store.dispatch('app/filterProp', {value: n, name: 'name'})
    },

    companies(n, o) {
      this.$store.dispatch('app/filterProp', {value: n, name: 'company'})
    },
  },

  methods: {
    reset() {
      this.name = ''
      this.companies = []
    },

    getCompanyName(value) {
      const company = this.$store.getters['companies/list'].find(e => +e.id === +value)
      return company ? company.name : '-'
    },
  },
}
</script>
